import {AfterViewInit, Component, HostBinding, Input, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsConfig} from '../../../util/cls-config';
import {ClsUtil} from '../../../util/cls-util';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {GenericoService} from '../../../core/services/generico.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from '../../../clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsVendedores} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from 'src/app/core/models/cls-pegado';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-vendedores',
  templateUrl: './vendedores.component.html',
  styleUrls: ['./vendedores.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    PasteHandlerNeodataDirective,
    MasOpcionesGridComponent,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxRippleModule,
    IgxRippleDirective,
    FormsModule,
    UppercaseDirective,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    ContextMenuGenericoComponent,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent
  ],
  providers: [SummaryPipeNeoPipe]
})
export class VendedoresComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private servicioGen = inject(GenericoService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridVendedores', {read: IgxGridComponent, static: true})
  public gridVendedores: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  @Input()
  public modoEdicion = true;

  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public errorAlCargar: boolean;
  public dataVendedores: ClsVendedores[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('vendedorHeaderTemplate', {static: true}) public vendedorHeaderTemplate: TemplateRef<any>;
  @ViewChild('vendedorEditorTemplate', {static: true}) public vendedorEditorTemplate: TemplateRef<any>;
  @ViewChild('nombreVendedorHeaderTemplate', {static: true}) public nombreVendedorHeaderTemplate: TemplateRef<any>;
  @ViewChild('nombreVendedorEditorTemplate', {static: true}) public nombreVendedorEditorTemplate: TemplateRef<any>;
  @ViewChild('cargoVendedorEditorTemplate', {static: true}) public cargoVendedorEditorTemplate: TemplateRef<any>;
  @ViewChild('telefonoVendedorEditorTemplate', {static: true}) public telefonoVendedorEditorTemplate: TemplateRef<any>;
  @ViewChild('mailVendedorEditorTemplate', {static: true}) public mailVendedorEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridVendedores.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Vendedores, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Vendedores);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'Vendedor':
        column.headerTemplate = this.vendedorHeaderTemplate;
        column.inlineEditorTemplate = this.vendedorEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'NombreVendedor':
        column.headerTemplate = this.nombreVendedorHeaderTemplate;
        column.inlineEditorTemplate = this.nombreVendedorEditorTemplate;
        break;
      case 'CargoVendedor':
        column.inlineEditorTemplate = this.cargoVendedorEditorTemplate;
        break;
      case 'TelefonoVendedor':
        column.inlineEditorTemplate = this.telefonoVendedorEditorTemplate;
        break;
      case 'MailVendedor':
        column.inlineEditorTemplate = this.mailVendedorEditorTemplate;
        break;
    }
    // column.cellClasses = this.backgroundClasses;
  }

  public async cargarVendedores() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataVendedores = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarVendedores2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(item => {
          const vendedor: ClsVendedores = {
            IdVendedor: item.IdVendedor,
            Vendedor: item.Vendedor,
            NombreVendedor: item.NombreVendedor,
            CargoVendedor: item.CargoVendedor,
            TelefonoVendedor: item.TelefonoVendedor,
            MailVendedor: item.MailVendedor
          };
          this.dataVendedores.push(vendedor);
        });
        this.gridVendedores.data = this.dataVendedores;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Vendedores, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Vendedores);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridVendedores.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridVendedores.filteringLogic = FilteringLogic.Or;
    this.gridVendedores.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateVendedor(vendedor: IGridEditDoneEventArgs) {
    const newValor: ClsVendedores = vendedor.newValue;
    const oldValor: ClsVendedores = vendedor.oldValue;
    if (vendedor.isAddRow) {
      await this.agregarModificarVendedor(newValor, oldValor, vendedor.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Vendedores)) {
        await this.agregarModificarVendedor(newValor, oldValor, vendedor.isAddRow);
      }
    }
  }

  private async agregarModificarVendedor(newVendedor: ClsVendedores, oldVendedor: ClsVendedores, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsVendedores = new ClsVendedores();
    try {
      // objCatalogo.IdVendedorSql = isAddRow ? BigInt('0') : newVendedor.IdVendedorSql;
      objCatalogo.IdVendedor = isAddRow ? BigInt('0') : newVendedor.IdVendedor;
      objCatalogo.Vendedor = newVendedor.Vendedor.toUpperCase();
      objCatalogo.CargoVendedor = newVendedor.CargoVendedor;
      objCatalogo.MailVendedor = newVendedor.MailVendedor;
      objCatalogo.NombreVendedor = newVendedor.NombreVendedor;
      objCatalogo.TelefonoVendedor = newVendedor.TelefonoVendedor;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'VendedoresRegistraActualiza2021');
      if (isAddRow) {
        newVendedor.IdVendedor = respuesta;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateVendedores(newVendedor, oldVendedor, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateVendedores(newVendedor: ClsVendedores, oldVendedor: ClsVendedores, isAddRow: boolean) {
    if (isAddRow) {
      this.gridVendedores.deleteRowById(newVendedor.IdVendedor);
    } else {
      this.gridVendedores.updateRow(oldVendedor, oldVendedor.IdVendedor);
    }
  }

  private async eliminarVendedor(rowContext: RowType) {
    const vendedor: ClsVendedores = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(vendedor.IdVendedor, 'EliminarVendedores2021');
      this.gridVendedores.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de toda la fila se cancela la edicion y se manda mensaje de que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarVendedor(vendedor: IGridEditEventArgs) {
    const valor: ClsVendedores = vendedor.newValue;
    vendedor.cancel = this.esValido(valor, vendedor, vendedor.isAddRow);
  }

  // en este caso se pasa toda la clase, porque es más de un campos a validar: Vendedor y Nommbre, ya que son los únicos obligatorios
  private esValido(vendedores: ClsVendedores, vend: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(vendedores.Vendedor)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.VENDEDOR.COL_VENDEDOR')));
      return true;
    }

    if (ClsUtil.esNulo(vendedores.NombreVendedor)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.VENDEDOR.COL_NOMBRE')));
      return true;
    }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataVendedores.findIndex(vendedor => vendedor.Vendedor === vendedores.Vendedor) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(vendedores.Vendedor));
        return true;
      }
    } else {
      if (vendedores.Vendedor !== vend.oldValue.Vendedor) {
        if (this.dataVendedores.findIndex(vendedor => vendedor.Vendedor === vendedores.Vendedor) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(vendedores.Vendedor));
          return true;
        }
      }
    }
    return false;
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridVendedores, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion((resp: boolean) => {
            if (resp) {
              this.eliminarVendedor(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.Vendedor));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridVendedores, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.VENDEDORES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridVendedores.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridVendedores,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.VENDEDORES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarVendedores();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
  public handleRowSelection() {
    this.gridVendedores.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      let arrayVendedores: ClsVendedores[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colVen: string = this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_VENDEDOR');
      const colNom: string = this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_NOMBRE');
      const colCar: string = this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_CARGO');
      const colTel: string = this.mObjGenerico.getTranslationsSubject('GRIDS.VENDEDOR.COL_TELEFONO');
      const colMail = 'Mail';
      this.mObjCopiado.columnasRequeridas = [colVen, colNom];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Vendedores);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, [colVen, colNom, colCar, colTel, colMail], [colVen, colNom], EnumNombresGrids.Vendedores);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valVen: string = (x[colVen] as string).toUpperCase();
            // validamos la cadena, si es undifine o null, le asignamos '' en caso contrario el valor
            // esto se hace porque la columna descripcion no es obligado, puede venir o no
            const valNom: string = ClsUtil.cadenaX(x[colNom] as string);
            const valCar: string = ClsUtil.cadenaX(x[colCar] as string);
            const valTel: string = ClsUtil.cadenaX(x[colTel] as string);
            const valMail: string = ClsUtil.cadenaX(x[colMail] as string);
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataVendedores, [valVen, valNom, valCar, valTel, valMail], [colVen, colNom, colCar, colTel, colMail], EnumTresPuntos.Vendedores, this.mObjGenerico);
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                arrayVendedores.push(resp.obj);
              } else {
                this.gridVendedores.updateCell(valVen, resp.obj.IdFamilia, 'Vendedor');
                this.gridVendedores.updateCell(valNom, resp.obj.IdFamilia, 'NombreVendedor');
                this.gridVendedores.updateCell(valCar, resp.obj.IdFamilia, 'CargoVendedor');
                this.gridVendedores.updateCell(valTel, resp.obj.IdFamilia, 'TelefonoVendedor');
                this.gridVendedores.updateCell(valMail, resp.obj.IdFamilia, 'MailVendedor');
                arrayVendedores.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayUnidades tenga valor
          if (arrayVendedores.length > 0) {
            const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayVendedores, 'VendedoresRegistraActualiza2021', false);
            // filtro los registros con id 0
            arrayVendedores = arrayVendedores.filter(value => value.IdVendedor === BigInt(0));
            // iteramos la respuesta para ir asignando los ids para los registros nuevos
            const key: string[] = Object.keys(respuesta);
            key.forEach(x => {
              const ven: ClsVendedores = arrayVendedores.find(value1 => value1.Vendedor === x);
              if (!ClsUtil.esNulo(ven)) {
                ven.IdVendedor = ClsUtil.bigintX(respuesta[x]);
                this.gridVendedores.addRow(ven);
              }
            });
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async customKeydown(eventArgs) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridVendedores, 'IdVendedor', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridVendedores.clearSort();
    this.gridVendedores.clearFilter();
    this.gridVendedores.clearSearch();
    this.gridVendedores.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridVendedores.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridVendedores.getRowData(rowSeleccionados[0]);
      this.gridVendedores.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
